// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd6ed247","956":"1f59859f"}[chunkId] + ".chunk.js";
};